let logoutCallback = null;
let refreshPromise = null;

export const registerLogoutCallback = (cb) => {
  logoutCallback = cb;
};

const performTokenRefresh = async () => {
  try {
    const refreshRes = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include'
    });
    return refreshRes.ok;
  } catch (refreshErr) {
    console.error('Session refresh failed:', refreshErr);
    return false;
  }
};

export const apiFetch = async (url, options = {}) => {
  options.credentials = 'include';
  options.headers = options.headers || {};
  
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json';
  }

  let response = await fetch(url, options);

  // If 401 Unauthorized, intercept and refresh
  if (response.status === 401 && !url.includes('/api/auth/refresh') && !url.includes('/api/auth/login')) {
    if (!refreshPromise) {
      refreshPromise = performTokenRefresh().finally(() => {
        refreshPromise = null;
      });
    }

    const refreshSuccess = await refreshPromise;

    if (refreshSuccess) {
      // Retry the original request
      response = await fetch(url, options);
    } else {
      // Refresh failed -> logout user
      if (logoutCallback) {
        logoutCallback();
      }
      window.location.href = '/login';
    }
  }

  return response;
};
